/**
 * Pre-compiled localized messages for Drawer component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import drawerMessages_en from "./intl/en";
import drawerMessages_de from "./intl/de";
import drawerMessages_es from "./intl/es";
import drawerMessages_fr from "./intl/fr-FR";
import drawerMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const drawerMessagesStrings: LocalizedStrings<string, LocalizedString> =
  {
    en: normalizeMessages(drawerMessages_en),
    de: normalizeMessages(drawerMessages_de),
    es: normalizeMessages(drawerMessages_es),
    "fr-FR": normalizeMessages(drawerMessages_fr),
    "pt-BR": normalizeMessages(drawerMessages_pt),
  } as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Drawer component
 */
export type DrawerMessageKey = "closeTrigger";
